/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Field_Total_TimeInputs */

const en_field_total_time = /** @type {(inputs: Field_Total_TimeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Total Time (Airframe Hours)`)
};

const es_field_total_time = /** @type {(inputs: Field_Total_TimeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tiempo total (Horas de vuelo)`)
};

const fr_field_total_time = /** @type {(inputs: Field_Total_TimeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Temps total (Heures de vol)`)
};

const de_field_total_time = /** @type {(inputs: Field_Total_TimeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gesamtzeit (Flugstunden)`)
};

const ja_field_total_time = /** @type {(inputs: Field_Total_TimeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`総飛行時間 (機体時間)`)
};

const zh_field_total_time = /** @type {(inputs: Field_Total_TimeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`总时长 (机身小时数)`)
};

const ar_field_total_time = /** @type {(inputs: Field_Total_TimeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`الوقت الإجمالي (ساعات الطيران)`)
};

const id_field_total_time = /** @type {(inputs: Field_Total_TimeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Waktu Total (Jam Badan Pesawat)`)
};

const it_field_total_time = /** @type {(inputs: Field_Total_TimeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ore Totali di Volo`)
};

const ru_field_total_time = /** @type {(inputs: Field_Total_TimeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Общий налет (часы)`)
};

const pt_field_total_time = /** @type {(inputs: Field_Total_TimeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tempo Total (Horas de Voo)`)
};

const ko_field_total_time = /** @type {(inputs: Field_Total_TimeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`총 비행 시간`)
};

/**
* | output |
* | --- |
* | "Total Time (Airframe Hours)" |
*
* @param {Field_Total_TimeInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const field_total_time = /** @type {((inputs?: Field_Total_TimeInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Field_Total_TimeInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_field_total_time(inputs)
	if (locale === "es") return es_field_total_time(inputs)
	if (locale === "fr") return fr_field_total_time(inputs)
	if (locale === "de") return de_field_total_time(inputs)
	if (locale === "ja") return ja_field_total_time(inputs)
	if (locale === "zh") return zh_field_total_time(inputs)
	if (locale === "ar") return ar_field_total_time(inputs)
	if (locale === "id") return id_field_total_time(inputs)
	if (locale === "it") return it_field_total_time(inputs)
	if (locale === "ru") return ru_field_total_time(inputs)
	if (locale === "pt") return pt_field_total_time(inputs)
	return ko_field_total_time(inputs)
});